import {GRID_HEADER_FONT_SIZE, MONTH_GRID_OFFSET_X} from "@/event/calendar/Constants.ts";
import {weekdayName, weekdayShortName} from "@/event/calendar/Formating.ts";
import {Component} from "@/event/calendar/dom/Component.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {distributeGridSpace, Rect} from "@/event/calendar/Shapes.ts";
import {weekInfo} from "@fd/editors/temporal/CalendarWidgetTypes.ts";
import {shiftDate} from "@t/util/DateUtil.ts";


export class WeeksHeaderComponent extends Component {
	constructor() {
		super();
	}

	protected drawBackground(dc: DrawingContext, area: Rect) {
		dc.ctx.fillStyle = dc.style.getPropertyValue("--cal-header-bg");
		dc.ctx.fillRect(area.x, area.y, area.width, area.height);

		const fontFamily = dc.style.getPropertyValue("--font");
		dc.ctx.font = GRID_HEADER_FONT_SIZE + "px "+fontFamily;
		dc.ctx.fillStyle = dc.style.getPropertyValue("--cal-header-fg");

		const ms = dc.ctx.measureText("x");	// to find baseline
		const textLineHeight = ms.fontBoundingBoxAscent + ms.fontBoundingBoxDescent;
		const baseline = Math.floor(((area.height - 1 - textLineHeight) / 2) + ms.fontBoundingBoxAscent + 1);

		const hgrid = distributeGridSpace(this.width, 7);
		const wi = weekInfo();
		const dateFD = wi.firstDay % 7; // week info has different numbering of weekdays then Date() class
		let date = new Date();
		while (date.getDay() !== dateFD) shiftDate(date, -1);

		let first = true;
		for (let i = 0; i < hgrid.length; i++) {
			const slot = hgrid[i];
			let dayName = slot.size > 60 ? weekdayName(date) : weekdayShortName(date);
			dc.ctx.fillText(dayName, slot.start + MONTH_GRID_OFFSET_X, baseline);
			if (i < hgrid.length - 1) {
				dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-day-separ");
				dc.ctx.beginPath();
				dc.ctx.moveTo(slot.gapLine, area.y);
				dc.ctx.lineTo(slot.gapLine, area.y + area.height);
				dc.ctx.stroke();

			}
			shiftDate(date);
		}
		dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-separ");
		dc.ctx.beginPath();
		dc.ctx.moveTo(0, this.height - 0.5);
		dc.ctx.lineTo(this.width, this.height - 0.5);
		dc.ctx.stroke();

	}
}
